import React from 'react'
import { useModalState } from 'src/Modal/ModalStateContext'
import {
  EvidenceNoResultsContainer,
  EvidenceNoResultsIcon,
  EvidenceNoResultsTitle,
} from 'src/pages/Evidence/evidence.styles'
import { PERMISSIONS } from 'src/config/roleConfig'
import { ModalFormId } from 'src/components/ModalForms'
import {
  PrimaryButton,
  StandardButtonSize,
} from 'src/components/Reusable/Buttons'

export const ControlsTabNoResults = (): JSX.Element => {
  const { openModal } = useModalState()
  return (
    <EvidenceNoResultsContainer>
      <EvidenceNoResultsTitle $isWarning>
        <EvidenceNoResultsIcon />
        This evidence isn&apos;t linked to any controls.
      </EvidenceNoResultsTitle>
      <PrimaryButton
        size={StandardButtonSize.MEDIUM}
        requiredPermissions={[PERMISSIONS.EDIT]}
        text="Link to Controls"
        onClick={() => {
          openModal(ModalFormId.LINK_EVIDENCE_TO_CONTROLS)
        }}
      />
    </EvidenceNoResultsContainer>
  )
}
